import { render } from "./InvoiceTickets.vue?vue&type=template&id=4db98d72"
import script from "./InvoiceTickets.vue?vue&type=script&lang=js"
export * from "./InvoiceTickets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__